/**
 * UI 與設定相關常量
 */

// 分頁相關
export const PAGE_SIZE = 20;
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100];

// UI 時間常量
export const TOAST_DURATION = 3000;
export const LOADING_DELAY = 300;
export const ANIMATION_DURATION = 200;
export const SEARCH_TIMEOUT = 500;

// 預設值
export const DEFAULT_LANGUAGE = 'zh-TW';
export const DEFAULT_THEME = 'light';
export const DEFAULT_TIMEZONE = 'Asia/Taipei';
